import React from "react";

import PropTypes from "prop-types";
import styled from "styled-components";

import { fonts, colors } from "../../../styles/variables";
import breakpoints from "../../../styles/breakpoints";

import RadioGroup from "../RadioGroup";
import Image from "../Image";

import radioIcon from "../../../assets/images/icons/check-white.svg";

const InterrogationRadioGroup = styled(RadioGroup)`
  margin-left: 20px;
  margin-right: 20px;
  display: flex;
  justify-content: space-between;
  position: relative;
  flex: 1;
  ${breakpoints.xsDown} {
    margin-left: 10px;
    margin-right: 10px;
  }
  &:before {
    content: "";
    position: absolute;
    left: 0;
    bottom: 18px;
    width: 100%;
    height: 1px;
    background-color: ${colors.black};
  }
`;

const InterrogationRadioImage = styled(Image)`
  max-width: 60px;
  ${breakpoints.xsDown} {
    max-width: 40px;
  }
`;

const RadioLabel = styled.label`
  display: block;
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  &:first-child {
    text-align: left;
    > span {
      &:before {
        left: 0;
        transform: translateX(0);
      }
    }
  }
  &:last-child {
    text-align: right;
    > span {
      &:before {
        left: auto;
        right: 0;
        transform: translateX(0);
      }
    }
  }
  ${(props) => props.css};
`;

const RadioText = styled.span`
  display: inline-block;
  font-size: 35px;
  line-height: 1;
  font-family: ${fonts.fontInterstateBlackCompressed};
  padding-top: 0;
  padding-bottom: 60px;
  position: relative;
  &:before {
    content: "";
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    border: 1px solid ${colors.black};
    background-color: ${colors.white};
    background-repeat: no-repeat;
    background-position: 50% 50%;
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    ${breakpoints.xsDown} {
      width: 30px;
      height: 30px;
    }
  }

  ${(props) => props.css}
`;

const RadioInput = styled.input`
  display: none;
  opacity: 0;
  visibility: hidden;
  &[aria-checked="true"] + ${RadioText} {
    &:before {
      background-color: ${colors.black};
      background-color: ${(props) => props.danger && colors.danger};
      background-color: ${(props) => props.success && colors.success};
      background-image: url("${radioIcon}");
      border-width: ${(props) => (props.hideBorder ? 0 : 1)};
    }
  }
`;

const InterrogationRadio = (
  {
    label = "",
    value = "",
    isDefault = false,
    danger = false,
    success = false,
    forceChecked = false,
    radioTextStyle = [],
    hideFeedbackBorder = false,
    radioLabelStyle = [],
  },
  context
) => {
  const {
    radioGroup: { name, selectedValue, onChange, disabled, type },
  } = context;
  const isCheckedByDefault = selectedValue === null && isDefault;
  const isChecked = value === selectedValue || isCheckedByDefault;
  return (
    <RadioLabel disabled={disabled} css={radioLabelStyle}>
      <RadioInput
        value={value}
        aria-checked={isChecked || forceChecked}
        type={type}
        name={name}
        onChange={() => onChange(value)}
        checked={isChecked || forceChecked}
        danger={danger}
        success={success}
        disabled={disabled}
        hideBorder={hideFeedbackBorder}
      />
      <RadioText css={radioTextStyle}>{label}</RadioText>
    </RadioLabel>
  );
};

InterrogationRadio.contextTypes = {
  radioGroup: PropTypes.shape({}),
};

InterrogationRadio.propTypes = {
  isDefault: PropTypes.bool,
  label: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  danger: PropTypes.bool,
  success: PropTypes.bool,
  forceChecked: PropTypes.bool,
  radioTextStyle: PropTypes.arrayOf(PropTypes.string),
  radioLabelStyle: PropTypes.arrayOf(PropTypes.string),
  hideFeedbackBorder: PropTypes.bool,
};

export { InterrogationRadio, InterrogationRadioGroup, InterrogationRadioImage };
